import BitSet from '../bitset/Bitset';

export class Codecs {
  static __static_initialized: boolean = false;
  static base64EncMap: number[] = [0];
  static base64DecMap: number[] = [0];
  static dontNeedEncoding: BitSet = new BitSet(256);
  static CASEDIFF: number = 32;
  static dfltEncName: string = '';

  static __static_initialize() {
    if (!Codecs.__static_initialized) {
      Codecs.__static_initialized = true;
      Codecs.__static_initializer_0();
    }
  }

  public static base64EncMap_$LI$(): number[] {
    Codecs.__static_initialize();
    return Codecs.base64EncMap;
  }

  public static base64DecMap_$LI$(): number[] {
    Codecs.__static_initialize();
    return Codecs.base64DecMap;
  }

  public static dontNeedEncoding_$LI$(): BitSet {
    Codecs.__static_initialize();
    return Codecs.dontNeedEncoding;
  }
  public static dfltEncName_$LI$(): string {
    Codecs.__static_initialize();
    return Codecs.dfltEncName;
  }

  constructor () {
  }

  public static base64Encode(array: number[]): number[] {
    let array2: number[] = null;

    if (array != null) {
      array2 = (s => { let a = []; while (s-- > 0) a.push(0); return a; })(((array.length + 2) / 3 | 0) * 4);
      let i: number = 0;
      let j: number = 0;
      while ((i < array.length - 2)) {
        {
          array2[j++] = Codecs.base64EncMap_$LI$()[array[i] >>> 2 & 63];
          array2[j++] = Codecs.base64EncMap_$LI$()[(array[i + 1] >>> 4 & 15) | (array[i] << 4 & 63)];
          array2[j++] = Codecs.base64EncMap_$LI$()[(array[i + 2] >>> 6 & 3) | (array[i + 1] << 2 & 63)];
          array2[j++] = Codecs.base64EncMap_$LI$()[array[i + 2] & 63];
          i += 3;
        }
      };
      if (i < array.length) {
        array2[j++] = Codecs.base64EncMap_$LI$()[array[i] >>> 2 & 63];
        if (i < array.length - 1) {
          array2[j++] = Codecs.base64EncMap_$LI$()[(array[i + 1] >>> 4 & 15) | (array[i] << 4 & 63)];
          array2[j++] = Codecs.base64EncMap_$LI$()[array[i + 1] << 2 & 63];
        } else {
          array2[j++] = Codecs.base64EncMap_$LI$()[array[i] << 4 & 63];
        }
      }
      while ((j < array2.length)) {
        {
          array2[j] = 61;
          ++j;
        }
      };
    }
    return array2;
  }

  static __static_initializer_0() {
    Codecs.base64EncMap = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 47];
    Codecs.base64DecMap = (s => { let a = []; while (s-- > 0) a.push(0); return a; })(128);
    for (let i: number = 0; i < Codecs.base64EncMap_$LI$().length; ++i) {
      {
        Codecs.base64DecMap_$LI$()[Codecs.base64EncMap_$LI$()[i]] = (<number>i | 0);
      };
    }
    Codecs.dfltEncName = null;
    Codecs.dontNeedEncoding = new BitSet(256);

    for (let j: number = 97; j <= 122; ++j) {
      {
        Codecs.dontNeedEncoding_$LI$().set(j);
      };
    }
    for (let k: number = 65; k <= 90; ++k) {
      {
        Codecs.dontNeedEncoding_$LI$().set(k);
      };
    }
    for (let l: number = 48; l <= 57; ++l) {
      {
        Codecs.dontNeedEncoding_$LI$().set(l);
      };
    }
    Codecs.dontNeedEncoding_$LI$().set(32);
    Codecs.dontNeedEncoding_$LI$().set(45);
    Codecs.dontNeedEncoding_$LI$().set(95);
    Codecs.dontNeedEncoding_$LI$().set(46);
    Codecs.dontNeedEncoding_$LI$().set(42);
    Codecs.dfltEncName = "UTF8";
  }
}
